import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import CoreChip from './CoreChip';
import DictProgress from './DictProgress';
import { CoreDictionaryMeta } from '../coreMeta';

interface ICoreDictionaryCardProps {
  meta: CoreDictionaryMeta;
  name: string;
  total: number;
  learned: number;
}

const CoreDictionaryCard: React.FC<ICoreDictionaryCardProps> = ({
  meta,
  name,
  total,
  learned,
}) => {
  const navigate = useNavigate();
  return (
  <Box
    onClick={() => navigate(meta.to)}
    role={'link'}
    sx={{
      bgcolor: 'background.paper',
      border: 1,
      borderColor: 'primary.tableBorder',
      borderRadius: 2,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      minHeight: 220,
      p: '26px 24px 22px',
      transition: 'border-color .2s ease',
      '&:hover': { borderColor: meta.accent },
    }}
  >
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      spacing={1}
    >
      <Typography
        component={'h3'}
        sx={{
          color: meta.accent,
          flex: 1,
          fontSize: 19,
          fontWeight: 800,
          lineHeight: 1.2,
          m: 0,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </Typography>
      <CoreChip />
    </Stack>

    {/* Progress + CTA anchored to the bottom edge so they line up across
        cards of the same grid row regardless of description length. */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75, mt: 'auto', pt: 1 }}>
      <DictProgress total={total} learned={learned} />
      <Button
        fullWidth
        component={Link}
        to={meta.to}
        onClick={(e) => e.stopPropagation()}
        endIcon={<ArrowForwardIcon sx={{ fontSize: 18 }} />}
      >
        {'Відкрити'}
      </Button>
    </Box>
  </Box>
  );
};

export default CoreDictionaryCard;
